/* eslint-disable max-len */
import { ChartTypes } from '@configs/graph';
import { sortOrders } from '@constants/sort';
import { IReportConfig } from '@typings/reports';

const reportConfig: IReportConfig = {
    reportTitle: 'Интересы',
    tableDataType: 'static',
    defaultSort: {
        name: 'visitors',
        order: sortOrders.DESC,
    },
    numberOfGraphs: 'two',
    defaultGraphs: [
        ChartTypes.bar,
        ChartTypes.bar,
    ],
    graphDefaultMetrics: [
        'visitors',
        'page_views',
    ],
    tableDefaultMetrics: [
        'visitors',
        'page_views',
        'avg_view_depth',
    ],
    availableMetrics: [
        'visits',
        'avg_view_depth',
        'page_views',
        'visitors',
        'uid',
        'rambler_id',
        // 'bounces',
        // 'avg_industry_duration',
    ],
    disabledSortBy: ['title'],
    isShowTotals: true,
    availableTools: {
        numberOfGraphs: true,
        periodPicker: true,
        sample: true,
        activeSample: true,
        filters: true,
        savedFilters: true,
        detail: true,
    },
    reportHint: {
        message: 'Тематические разделы, которые, по версии Модели пользователя SberAds, также интересны посетителям вашего ресурса. '
            + '<br />Доступные показатели: посетители, отказы, глубина просмотра, визиты, просмотры, время на сайте.',
    },
};

export default reportConfig;
